module.exports = __webpack_public_path__ + "static/media/campfire-icon.5f4d189a.svg";